import React from "react";
import { Reveal } from "../hooks/useReveal";

const projects = [
  { slug: "dungeon", title: "Dungeon! Order of the Raven", role: "Audio Director · Cutscene Sound Design", description: "Original sound design for three cutscenes, from atmosphere to action.", video: "/videos/dungeon-sound-design.mp4", poster: "/images/dungeon-sound-design.jpg" },
  { slug: "ug", title: "UG", role: "Composer & Sound Designer", description: "Six dinosaur vocalizations selected from the 100 roars I created for UG.", video: "/videos/ug-sound-design.mp4", poster: "/images/ug-sound-design.jpg" },
  { slug: "monkey-doo", title: "Monkey Doo", role: "Composer & Sound Designer", description: "Original gameplay cues: lava impact, bamboo swing, speed boost, time’s up and victory.", video: "/videos/monkey-doo-sound-design.mp4", poster: "/images/monkey-doo-sound-design.jpg" },
];

export default function SoundDesignShowcase() {
  const pauseOtherVideos = (event) => {
    document.querySelectorAll("video").forEach((video) => {
      if (video !== event.currentTarget) video.pause();
    });
  };
  return (
    <section id="sound-design" className="scroll-mt-24 py-12 md:py-16 bg-[#11191e] text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.22em] text-amber-300">Original game audio</span>
          <h2 className="mt-3 text-3xl md:text-5xl font-semibold tracking-tight" style={{ fontFamily: "'Manrope', sans-serif" }}>Sound Design</h2>
          <p className="mt-4 mb-8 max-w-2xl text-white/70">Cinematic cutscenes, creature voices and gameplay feedback. Explore original sound design across three projects.</p>
        </Reveal>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {projects.map((project) => (
            <article key={project.slug} className="rounded-xl overflow-hidden border border-white/15 bg-white/5">
              <video controls playsInline preload="none" poster={project.poster} onPlay={pauseOtherVideos} aria-label={project.title + " sound design showcase"} className="block w-full aspect-video object-contain bg-black">
                <source src={project.video} type="video/mp4" />
                Your browser does not support video playback. <a href={project.video}>Open the video</a>.
              </video>
              <div className="p-5 md:p-6">
                <h3 className="text-xl font-semibold tracking-tight">{project.title}</h3>
                <p className="mt-2 text-sm text-amber-300">{project.role}</p>
                <p className="mt-3 text-sm leading-relaxed text-white/70">{project.description}</p>
                {project.slug !== "dungeon" && <p className="mt-3 text-xs text-white/45">Isolated original SFX showcase</p>}
              </div>
            </article>
          ))}
        </div>
        <a href="/contact" className="mt-8 inline-flex items-center rounded-full bg-amber-300 px-6 py-3 font-medium text-black hover:bg-amber-200 transition-colors">Discuss your game’s audio</a>
      </div>
    </section>
  );
}
